// Helpful Resource:
// https://medium.com/fullstackio/managing-state-in-vue-js-23a0352b1c87
// https://michaelnthiessen.com/state-management-without-vuex/
// https://vuedose.tips/creating-a-store-without-vuex-in-vue-js-2-6/
import Vue from 'vue';
import { MakeGraphQLQuery } from '../utils/helpers';

// Define Variables  – CREATE FOR LOOP TO REDUCE CODE
const totalSampleNumber = JSON.parse(
  window.localStorage.getItem('tena__num-of-samples')
);
const totalCompareNumber = JSON.parse(
  window.localStorage.getItem('tena__num-of-compare-products')
);
const compareProducts =
  JSON.parse(window.localStorage.getItem('tena__compare-product-list')) || [];
const sampleCartHandles =
  JSON.parse(window.localStorage.getItem('tena__sample-cart')) || [];
const customerIsLoggedIn = JSON.parse(
  window.localStorage.getItem('tena__customer-logged-in')
);
const customerAccessToken = JSON.parse(
  window.localStorage.getItem('tena__customer-access-token')
);

const quickShopHandle = JSON.parse(
  window.localStorage.getItem('tena__quickshop-handle')
);

const checkIfSampleCartArrayEmpty = () => {
  if (sampleCartHandles.value.length && totalSampleNumber) {
      return totalSampleNumber.value;
   } else {
      return 0;
   }
}

const checkIfSampleCartUndefined = () => {
 if (sampleCartHandles.value) {
    return checkIfSampleCartArrayEmpty();
 } else {
    return 0;
 }
}

// Global State
export const GlobalState = {
  state: {
    numOfCompareProducts: totalCompareNumber ? totalCompareNumber : 0,
    compareProductList:
      compareProducts.value !== undefined ? compareProducts.value : [],
    customerIsLoggedIn: customerIsLoggedIn ? customerIsLoggedIn.value : false,
    customerAccessTokenEncoded: customerAccessToken
      ? customerAccessToken.value
      : '',
    selectedCompareProductIds: {},
    quickShopHandle: quickShopHandle ? quickShopHandle.value : '',
  },

  // Getters
  getNumberOfSamples($this) {
    const number = $this.$storage.get('num-of-samples', 0);
    return number;
  },
  getSampleCart($this) {
    const sampleCart = $this.$storage.get('sample-cart', []); // Fallback Array
    return sampleCart;
  },
  getCompareList($this) {
    const compareList = $this.$storage.get('compare-product-list', []); // Fallback Array
    return compareList;
  },
  getCustomerAccessToken($this) {
    const token = $this.$storage.get('customer-access-token');
    let decodedToken = atob(token);
    return decodedToken;
  },

  // Setters
  setCompareList($this, products) {
    $this.$storage.set('compare-product-list', products);
    this.state.compareProductList = products;
  },
  setNumberOfCompareProducts($this, newNumber) {
    $this.$storage.set('num-of-compare', Number(newNumber));
    const number = JSON.parse($this.$storage.get('num-of-compare', 0));
    this.state.numOfCompareProducts = number;
    store.compareCount = number;
  },
  setNumberOfSamples($this, newNumber) {
    $this.$storage.set('num-of-samples', Number(newNumber));
    const number = JSON.parse($this.$storage.get('num-of-samples', 0));
    this.state.numOfSampleProducts = number;
    store.count = number;
  },
  setCustomerLogin($this, state) {
    $this.$storage.set('customer-logged-in', state);
    this.state.customerIsLoggedIn = state;
  },
  setCustomerAccessToken: async function ($this, email, password) {
    // Create Customer Access Token, to Modify Customer Object

    if (!email || !password) {
      console.error('Error: Create Customer Access Token');
      return;
    }

    let customerToken;
    let $inputVariableObject = `{
      email: "${email}",
      password: "${password}",
    }`;

    const createCustomerAccessTokenMutation = `
      mutation {
        customerAccessTokenCreate(input: ${$inputVariableObject}) {
          customerAccessToken {
            accessToken
            expiresAt
          }
          customerUserErrors {
            message
          }
        }
      }`;
    try {
      customerToken = await MakeGraphQLQuery(
        `${window.theme.storeURL}/api/graphql.json`,
        createCustomerAccessTokenMutation
      );
      if (customerToken.errors) {
        return customerToken;
      } else {
        const { customerAccessToken, customerUserErrors } =
          customerToken.data.customerAccessTokenCreate;
        // Set Global State
        if (!customerUserErrors.length) {
          const { accessToken } = customerAccessToken;
          let encodedToken = btoa(accessToken);
          $this.$storage.set('customer-access-token', encodedToken, {
            ttl: 60 * 60 * 24 * 1000,
          }); // 24 hours
        }
        // Return Response
        return customerToken.data.customerAccessTokenCreate;
      }
    } catch (err) {
      return err;
    }
  },
  setQuickShopHandle($this, productHandle) {
    $this.$storage.set('quickshop-handle', productHandle);
    const handle = JSON.parse($this.$storage.get('quickshop-handle', ''));
    this.state.numOfSampleProducts = handle;
  },

  // Delete
  removeCustomerAccessToken: async function ($this, accessToken) {
    if (!accessToken) {
      return;
    }
    const deleteTokenQuery = `
      mutation {
        customerAccessTokenDelete(customerAccessToken: ${accessToken}) {
          deletedAccessToken
          deletedCustomerAccessTokenId
          userErrors {
            field
            message
          }
        }
      }`;

    try {
      deletedCustomerAccessToken = await MakeGraphQLQuery(
        `${window.theme.storeURL}/api/graphql.json`,
        deleteTokenQuery
      );
      if (deletedCustomerAccessToken.errors) {
        return deletedCustomerAccessToken;
      } else {
        const { deletedAccessToken, deletedCustomerAccessTokenId, userErrors } =
          customerToken.data.customerAccessTokenCreate;

        // Update Local Storage
        $this.$storage.remove('customer-access-token');
      }
    } catch (error) {}
  },
};

// Observable
// https://medium.com/better-programming/how-to-manage-vues-state-with-vue-observable-25988a88938b
export const store = Vue.observable({
  count: GlobalState.state.numOfSampleProducts,
  compareCount: GlobalState.state.numOfCompareProducts,
  quickShopHandle: GlobalState.state.quickShopHandle,
});
